<div class="header">
    <h2>{{ 'predefinedPathways.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="predefined-pathways-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'predefinedPathways.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'predefinedPathways.form.name' | translate"
            [placeholder]="'predefinedPathways.form.name.placeholder' | translate"
            inputId="name"
            testId="predefined-pathways-add-name"
        />

        <app-form-textarea
            [control]="form.controls.description"
            [label]="'predefinedPathways.form.description' | translate"
            [placeholder]="'predefinedPathways.form.description.placeholder' | translate"
            inputId="description"
            testId="predefined-pathways-add-description"
        />

        <app-form-select
            [control]="form.controls.type"
            [label]="'predefinedPathways.form.type' | translate"
            [placeholder]="'predefinedPathways.form.type.placeholder' | translate"
            [options]="typeOptions"
            inputId="type"
            testId="predefined-pathways-add-type"
        />
    </div>

    <div class="section">
        <h2>{{ 'predefinedPathways.fieldset.assignment' | translate }}</h2>
        <app-form-multiselect
            [control]="form.controls.schoolIds"
            [label]="'predefinedPathways.form.schools' | translate"
            [placeholder]="'predefinedPathways.form.schools.placeholder' | translate"
            [options]="schoolOptions()"
            [filter]="true"
            inputId="schoolIds"
            testId="predefined-pathways-add-school-ids"
        />

        <app-form-multiselect
            [control]="form.controls.organisationIds"
            [label]="'predefinedPathways.form.organisations' | translate"
            [placeholder]="'predefinedPathways.form.organisations.placeholder' | translate"
            [options]="organisationOptions()"
            [filter]="true"
            inputId="organisationIds"
            testId="predefined-pathways-add-organisation-ids"
        />
    </div>

    <div class="section">
        <app-predefined-pathway-course-list
            [courses]="selectedCourses()"
            (add)="openCourseDialog()"
            (remove)="removeCourse($event)"
            (reorder)="selectedCourses.set($event)"
        />
    </div>
</form>

<div class="footer">
    <p-button
        [label]="'predefinedPathways.form.cancel' | translate"
        [outlined]="true"
        severity="secondary"
        data-test="predefined-pathways-add-cancel"
        (onClick)="close()"
    />
    <p-button
        type="submit"
        [label]="'predefinedPathways.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="predefined-pathways-add-submit"
        (onClick)="onSubmit()"
    />
</div>
